module.exports = __webpack_public_path__ + "static/media/linkedIn-pink.a14b879c.svg";